export enum SessionStatus {
  Booked = 'booked',
  Completed = 'completed',
  Canceled = 'canceled',
  New = 'new',
  Skipped = 'skipped',
}
